document.addEventListener("DOMContentLoaded", () => {
  const PredictiveSearchProto = customElements.get("predictive-search")?.prototype;
  if (!PredictiveSearchProto) return;

  // Override the method
  PredictiveSearchProto._doPredictiveSearch = async function() {
    await this._transitionToSlot("loading");

    const queryParams = `q=${this._queryInput.value}&section_id=${this.getAttribute("section-id")}&resources[type]=product,page,article&resources[options][fields]=title,body,tag,variants.title&resources[limit]=10&resources[limit_scope]=each`;

    const response = await fetch(`${window.Shopify.routes.root}search/suggest?${queryParams}`, { signal: this._abortController.signal });
    const text = await response.text();
    const nodeElement = new DOMParser().parseFromString(text, "text/html");

    this.querySelector('[slot="results"]').replaceWith(
      document.importNode(nodeElement.querySelector('[slot="results"]'), true)
    );

    return this._transitionToSlot("results");
  };
});
